module.exports = __webpack_public_path__ + "static/media/Screenshot_5-thumb.dd8034e7.png";